import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "priceInput"]

  connect() {
    // Redondear precios automáticamente cuando la página carga
    // Esto se ejecuta después de calcular la actualización
    // Usar múltiples timeouts para asegurar que los valores estén cargados
    setTimeout(() => {
      this.roundPrices()
    }, 100)
    setTimeout(() => {
      this.roundPrices()
    }, 500)
    setTimeout(() => {
      this.roundPrices()
    }, 1000)

    // Abrir el modal automáticamente si hay un parámetro de página de historial
    this.openHistoryModalIfNeeded()
  }

  openHistoryModalIfNeeded() {
    // Verificar si hay un parámetro history_page en la URL
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('history_page')) {
      // Abrir el modal después de un pequeño delay para asegurar que esté renderizado
      setTimeout(() => {
        const modal = document.getElementById('priceHistoryModal')
        if (modal) {
          // Usar Bootstrap 4 API nativa o jQuery si está disponible
          if (typeof $ !== 'undefined' && $.fn.modal) {
            $(modal).modal('show')
          } else if (typeof bootstrap !== 'undefined') {
            // Bootstrap 5
            const bsModal = new bootstrap.Modal(modal)
            bsModal.show()
          } else {
            // Fallback: agregar clase y atributos necesarios
            modal.classList.add('show')
            modal.style.display = 'block'
            document.body.classList.add('modal-open')
            const backdrop = document.createElement('div')
            backdrop.className = 'modal-backdrop fade show'
            document.body.appendChild(backdrop)
          }
        }
      }, 300)
    }
  }

  roundPrices() {
    // Redondear todos los inputs de precio final hacia arriba para que terminen en 500 o 000
    const priceInputs = document.querySelectorAll('[data-meal-combos-target="priceInput"]')

    priceInputs.forEach((input) => {
      const currentValue = parseFloat(input.value)
      if (!isNaN(currentValue) && currentValue > 0) {
        // Obtener las últimas 3 cifras (módulo 1000)
        const lastThreeDigits = Math.round(currentValue) % 1000
        let roundedValue

        if (lastThreeDigits === 0) {
          // Ya termina en 000, no hacer nada
          roundedValue = currentValue
        } else if (lastThreeDigits <= 500) {
          // Redondear hacia arriba a 500
          roundedValue = Math.round(currentValue) - lastThreeDigits + 500
        } else {
          // Redondear hacia arriba a 1000 (siguiente múltiplo de 1000)
          roundedValue = Math.round(currentValue) - lastThreeDigits + 1000
        }

        // Solo actualizar si el valor cambió significativamente
        if (Math.abs(roundedValue - currentValue) > 0.01) {
          input.value = roundedValue.toFixed(2)
          // Disparar evento change para notificar cambios
          input.dispatchEvent(new Event('change', { bubbles: true }))
          input.dispatchEvent(new Event('input', { bubbles: true }))
        }
      }
    })
  }

  copyPricesToForm(event) {
    event.preventDefault()

    const form = this.formTarget
    // Buscar todos los inputs de precio en la página (no solo dentro del scope del controlador)
    const priceInputs = document.querySelectorAll('[data-meal-combos-target="priceInput"]')

    // Limpiar campos previos si existen
    form.querySelectorAll('input[name^="meal_combos["]').forEach(input => {
      if (input.type === 'hidden') {
        input.remove()
      }
    })

    // Copiar todos los precios finales de la tabla al formulario de guardar
    // Usar el comboId como índice para que coincida con el formato esperado por combo_params
    priceInputs.forEach((input) => {
      const comboId = input.dataset.comboId
      const value = input.value

      // Asegurarse de que tenemos un valor válido (no vacío)
      if (comboId && value !== null && value !== undefined && value.toString().trim() !== '') {
        // Crear campo oculto para el ID del combo
        // El formato debe ser meal_combos[comboId][id] donde comboId es el ID del combo
        const idInput = document.createElement('input')
        idInput.type = 'hidden'
        idInput.name = `meal_combos[${comboId}][id]`
        idInput.value = comboId
        form.appendChild(idInput)

        // Crear campo oculto para el precio final
        const priceInput = document.createElement('input')
        priceInput.type = 'hidden'
        priceInput.name = `meal_combos[${comboId}][final_price_amount]`
        priceInput.value = value.toString().trim()
        form.appendChild(priceInput)
      }
    })

    // Enviar el formulario
    form.submit()
  }
}
